// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .beer-logo {
  width: 100%;
}
:host .beer-logo-cell {
  max-width: 80px;
  max-height: 60px;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
}
:host img {
  max-width: 80px;
  max-height: 60px;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
}
:host .beer-info-cell {
  text-overflow: ellipsis;
}
:host .beer-name {
  font-weight: normal;
  font-size: 18px;
}
:host .brewery-name {
  font-size: 14px; /*0.8em;*/
}
:host .subtitle {
  padding-left: 2px;
  font-size: 13px; /*0.9em;*/
  line-height: 13px;
}
:host .beer-value {
  padding-right: 10px;
}
:host .rating-wrapper {
  margin-right: 10px;
}
:host .rating-drop {
  width: 10px;
  height: 10px;
  padding: 0;
  margin-left: 1px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
